import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { formatNumber } from '../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../service/Pluralize/Pluralize';
import { CurrencyCode, GdRecommendationSign } from '../../typings/graphql-grid';

import './RecommendationKpiInfo.css';
import * as keyset from './RecommendationKpiInfo.i18n';

const i18n = i18nFactory(keyset);

export enum RecommendationKpiType {
    clicks = 'clicks',
    ctr = 'ctr'
}

export interface RecommendationKpiInfoProps {
    cls?: string;
    currency: CurrencyCode;
    periodValue: number;
    kpi: {
        type: RecommendationKpiType;
        value: number;
    };
    cost: number;
    sign?: GdRecommendationSign;
}

export class RecommendationKpiInfo extends React.PureComponent<
    RecommendationKpiInfoProps
> {
    render() {
        const { cls, kpi, cost, currency, periodValue } = this.props;

        return (
            <div
                className={classNames(Bem.cls('recommendation-kpi-info'), cls)}
            >
                <div className={Bem.cls('recommendation-kpi-info', 'list')}>
                    <div
                        className={Bem.cls(
                            'recommendation-kpi-info',
                            'list-item'
                        )}
                    >
                        <div
                            className={Bem.cls(
                                'recommendation-kpi-info',
                                'list-title'
                            )}
                        >
                            {this.getKpiTitle()}
                        </div>

                        <div
                            className={Bem.cls(
                                'recommendation-kpi-info',
                                'list-desc'
                            )}
                        >
                            +{formatNumber(kpi.value, 0)}
                        </div>
                    </div>

                    <div
                        className={Bem.cls(
                            'recommendation-kpi-info',
                            'list-item'
                        )}
                    >
                        <div
                            className={Bem.cls(
                                'recommendation-kpi-info',
                                'list-title'
                            )}
                        >
                            {pluralizeWord(
                                [
                                    i18n('one-day-cost-title', {
                                        value: periodValue
                                    }),
                                    i18n('some-days-cost-title', {
                                        value: periodValue
                                    }),
                                    i18n('many-days-cost-title', {
                                        value: periodValue
                                    })
                                ],
                                periodValue
                            )}
                        </div>

                        <div
                            className={Bem.cls({
                                block: 'recommendation-kpi-info',
                                elem: 'list-desc',
                                mods: { cost: true }
                            })}
                        >
                            +{formatNumber(cost, 0)}{' '}
                            {mapStringToCurrencySymbol(currency)}
                        </div>
                    </div>
                </div>

                {this.getKpiSign()}
            </div>
        );
    }

    private getKpiSign() {
        // https://st.yandex-team.ru/DIRECT-87895
        // Тут должен будет формироваться текст про то что рекомендация рассчитана с учетом sign - CPC, CPA, ROI.
        // Сейчас бекенд присылает нам sign, но сам его не учитывает.
        //
        //  const { sign } = this.props;
        //
        //  if (!sign) {
        //      return null;
        //  }
        //
        //  const dictionary = {
        //      [GdRecommendationSign.CPA]: i18n('cpa-sign'),
        //      [GdRecommendationSign.CPC]: i18n('cpc-sign'),
        //      [GdRecommendationSign.ROI]: i18n('roi-sign')
        //  };
        //
        //  if (!dictionary[sign]) {
        //      throw new Error(
        //          `Не определена подпись для kpi рекомендации с типом ${sign}`
        //      );
        //  }
        //
        //  return (
        //      <span className={Bem.cls('recommendation-kpi-info', 'sign')}>
        //          {dictionary[sign]}
        //      </span>
        //  );
    }

    private getKpiTitle() {
        const {
            kpi: { type },
            periodValue
        } = this.props;
        const dictionary = {
            [RecommendationKpiType.clicks]: pluralizeWord(
                [
                    i18n('one-day-clicks-title', { value: periodValue }),
                    i18n('some-days-clicks-title', { value: periodValue }),
                    i18n('many-days-clicks-title', { value: periodValue })
                ],
                periodValue
            ),
            [RecommendationKpiType.ctr]: pluralizeWord(
                [
                    i18n('one-day-ctr-title', { value: periodValue }),
                    i18n('some-days-ctr-title', { value: periodValue }),
                    i18n('many-days-ctr-title', { value: periodValue })
                ],
                periodValue
            )
        };

        if (!dictionary[type]) {
            throw new Error(
                `Для kpi рекомендации с типом ${type} не определен заголовок`
            );
        }

        return dictionary[type];
    }
}
